var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.id)?_c('div',{staticClass:"container",staticStyle:{"padding-bottom":"20vh","padding-top":"100px"}},[_c('app-profile-view',{attrs:{"user":_vm.user,"city":_vm.user.city}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-434c3f38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/employers/profile/PublicProfile.vue
// module id = 690
// module chunks = 0